import { useEffect } from 'react';

const DEFAULT_TITLE = 'Science Sorted | GCSE & A Level Science Tuition';

/**
 * Sets `document.title` for the current route and restores the default
 * when the component unmounts (in case of unusual navigation flows).
 *
 * Usage:
 *   usePageTitle('Science Courses | Science Sorted');
 */
export function usePageTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title || DEFAULT_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export { DEFAULT_TITLE };
